// extracted by mini-css-extract-plugin
module.exports = {"container":"DeviceError_container__13gT4","iconContainer":"DeviceError_iconContainer__2Bndl"};